import $ from "jquery";
// get #section-ISI
$(() => {
  const isiSection = $("#section-ISI");

  isiSection.each((index, element) => {
    const second = $(".second-content", element).clone();
    // add container class
    second.addClass("container d-lg-none");
    second.removeClass("d-none d-lg-block");
    // insert inside #second-title
    const secondTitle = $(".second-title", element);
    secondTitle.append(second);

    // region #section-ISI
    // Lets make the element sticky
    // clone the element and add it to the body
    const clonedElement = $(element).clone();
    // remove the id attribute to avoid duplicate ids
    clonedElement.removeAttr("id");
    $("body").append(clonedElement);
    const getHeight = () => {
      const isMobile = window.matchMedia("(max-width: 992px)").matches;
      return isMobile ? "250px" : "150px"; // Change height based on viewport
    };
    const getBottom = () => {
      const isMobile = window.matchMedia("(max-width: 992px)").matches;
      return isMobile ? "-30px" : "-0"; // Change height based on viewport
    };

    const height = getHeight();
    const bottom = getBottom();
    clonedElement.css({
      position: "fixed",
      bottom,
      left: 0,
      height,
      right: 0,
      zIndex: 1000,
    });
    // add cloned class
    clonedElement.addClass("cloned");

    // add a button to scroll to the original element
    $("a[data-button]", element).each((index, button) => {
      $("span", button).text($(button).data("button"));
      $(button).attr("href", `#`);
    });
    // Handle click for smooth scrolling with offset
    $("a[data-button]").on("click", (event) => {
      event.preventDefault();

      // Get the specific target element that triggered the event
      const targetId = $(event.currentTarget).attr("href");

      if (targetId === "#") {
        // Scroll to the top of the page
        $("html, body").animate(
          {
            scrollTop: 0,
          },
          200 // Animation duration in milliseconds
        );
      } else {
        // Handle scrolling to the target element
        const targetElement = $(`${targetId}`);

        if (targetElement.length) {
          // Calculate offset to account for static header height
          const headerHeight = $(".static-header").outerHeight() || 0; // Adjust selector as needed
          const targetPosition = targetElement.offset().top - headerHeight - 30; // Add some extra spacing (e.g., 10px)

          // Scroll smoothly to the adjusted position
          $("html, body").animate(
            {
              scrollTop: targetPosition,
            },
            200 // Animation duration in milliseconds
          );
        }
      }
    });

    const options = { rootMargin: `0px 0px -${height} 0px` };

    // use IntersectionObserver to check if the element is in view
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const isBelowFooter = entry.boundingClientRect.y < 0;
        clonedElement.toggleClass(
          "d-none",
          entry.isIntersecting || isBelowFooter
        );
      });
    }, options);

    // start observing the element
    observer.observe(element);

    // Update height on window resize
    $(window).on("resize", () => {
      const newHeight = getHeight();
      const newBottom = getBottom();
      clonedElement.css("height", newHeight);
      clonedElement.css("bottom", newBottom);
      observer.disconnect();
      observer.observe(element);
    });
  });
});
